export const MILLET_SIDEBAR_ACTION_COUNT_EVENT = 'millet-sidebar-action-count';
const SIDEBAR_ACTION_COUNT_STORAGE_KEY = 'millet.sidebarActionCount';

let currentCount = 0;

function readPersistedActionCount() {
  if (typeof window === 'undefined') return 0;
  try {
    const stored = Number(window.sessionStorage.getItem(SIDEBAR_ACTION_COUNT_STORAGE_KEY));
    if (Number.isFinite(stored) && stored > 0) return stored;
  } catch {
    /* ignore quota / private-mode errors */
  }
  return 0;
}

function persistActionCount(count) {
  if (typeof window === 'undefined') return;
  try {
    if (count > 0) {
      window.sessionStorage.setItem(SIDEBAR_ACTION_COUNT_STORAGE_KEY, String(count));
      return;
    }
    window.sessionStorage.removeItem(SIDEBAR_ACTION_COUNT_STORAGE_KEY);
  } catch {
    /* ignore quota / private-mode errors */
  }
}

export function getSidebarActionCount() {
  return currentCount > 0 ? currentCount : readPersistedActionCount();
}

export function formatSidebarActionCountLabel(count) {
  const n = Number(count) || 0;
  if (n === 1) return '1 item needs your attention';
  return `${n} items need your attention`;
}

export function formatSidebarActionCountBadge(count) {
  const n = Number(count) || 0;
  if (n > 99) return '99+';
  return String(n);
}

export function publishSidebarActionCount(count) {
  const next = Math.max(0, Number(count) || 0);
  currentCount = next;
  persistActionCount(next);
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(MILLET_SIDEBAR_ACTION_COUNT_EVENT, {
    detail: { count: next },
  }));
}

export function subscribeSidebarActionCount(listener) {
  if (typeof listener !== 'function') return () => {};
  listener(getSidebarActionCount());
  if (typeof window === 'undefined') return () => {};
  const onEvent = (event) => {
    listener(Number(event.detail?.count) || 0);
  };
  window.addEventListener(MILLET_SIDEBAR_ACTION_COUNT_EVENT, onEvent);
  return () => window.removeEventListener(MILLET_SIDEBAR_ACTION_COUNT_EVENT, onEvent);
}
